import { css } from 'styled-components';
import { useEffect } from 'react';
import { debounce } from 'lodash';
var DEBOUNCE_INTERVAL = 100;
var keys = Object.keys;
var Breakpoint;
(function (Breakpoint) {
  Breakpoint["mobile"] = "0";
  Breakpoint["tablet"] = "36rem";
  Breakpoint["desktop"] = "75rem";
  Breakpoint["xs"] = "0";
  Breakpoint["sm"] = "36rem";
  Breakpoint["md"] = "48rem";
  Breakpoint["lg"] = "62rem";
  Breakpoint["xl"] = "75rem";
})(Breakpoint || (Breakpoint = {}));

// FIXME: figure out what type this should be
function gte(breakpoint) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }
    return css(["@media (min-width:", "){", ";}"], Breakpoint[breakpoint], css(strings, ...interpolations));
  };
}
function between(gte, lt) {
  return function (strings) {
    for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    // TODO: lt needs to be lt - 1px
    return css(["@media (min-width:", ") and (max-width:", "){", ";}"], Breakpoint[gte], Breakpoint[lt], css(strings, ...interpolations));
  };
}
function throwErrorIfMixingBreakpoints(breakpoints) {
  if (breakpoints.includes('mobile') && breakpoints.includes('xs')) {
    throw new Error('Mobile and xs are synonyms for the same breakpoint, please use only one.');
  }
  if (breakpoints.includes('tablet') && breakpoints.includes('sm')) {
    throw new Error('Tablet and sm are synonyms for the same breakpoint, please use only one.');
  }
  if (breakpoints.includes('desktop') && breakpoints.includes('xl')) {
    throw new Error('Desktop and xl are synonyms for the same breakpoint, please use only one.');
  }
}
function map(values, mapValueToStyle) {
  if (typeof values !== 'object') {
    return mapValueToStyle(values);
  }
  var breakpoints = keys(values);
  throwErrorIfMixingBreakpoints(breakpoints); // sort the breakpoints(responsive-screens) in the order of Breakpoint values so that generated
  // css will always have the @media-queries in the order of mobile, tablet and desktop.

  breakpoints.sort((a, b) => parseFloat(Breakpoint[a]) - parseFloat(Breakpoint[b]));
  return breakpoints.reduce((accum, breakpoint) => {
    var template = gte(breakpoint);
    var value = values[breakpoint];
    var style = mapValueToStyle(value, breakpoint);
    return accum.concat(template([], style));
  }, [].concat(mapValueToStyle(undefined)));
}
var useBreakpoint = function useBreakpoint(callback, debounceInterval) {
  var useTshirt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return useEffect(() => {
    if (typeof window === 'undefined') return;
    var getBreakpointFunction = useTshirt ? getTshirtBreakpoint : getBreakpoint;
    var handleResize = debounce(() => callback(getBreakpointFunction()), debounceInterval || DEBOUNCE_INTERVAL);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
};
var getTshirtBreakpoint = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return 'xs';
  if (window.matchMedia("(min-width: ".concat(Breakpoint.xl, ")")).matches) return 'xl';else if (window.matchMedia("(min-width: ".concat(Breakpoint.lg, ")")).matches) return 'lg';else if (window.matchMedia("(min-width: ".concat(Breakpoint.md, ")")).matches) return 'md';else if (window.matchMedia("(min-width: ".concat(Breakpoint.sm, ")")).matches) return 'sm';
  return 'xs';
};
var getBreakpoint = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return 'mobile';
  if (window.matchMedia("(min-width: ".concat(Breakpoint.desktop, ")")).matches) return 'desktop';else if (window.matchMedia("(min-width: ".concat(Breakpoint.tablet, ")")).matches) return 'tablet';
  return 'mobile';
};
export { Breakpoint, between, getBreakpoint, getTshirtBreakpoint, gte, keys, map, useBreakpoint };